/* global navigator */
//import AudioManager from './AudioManager';
import { isChrome, isIOS } from 'react-device-detect';
import Gain from '../Audio/Gain';

const VIDEO_WIDTH = 1280;
const VIDEO_HEIGHT = 720;

export default class Manager {

    constructor(opt) {
        navigator.getUserMedia =
            navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

        if (typeof navigator.mediaDevices.getUserMedia === 'undefined')
            navigator.mediaDevices.getUserMedia = navigator.getUserMedia;        

        this._needAccept = false;
        this._isDeviceListReady = false;
        this._devices = {};

        this.onDeviceUpdate = opt.onDeviceUpdate;
        this.onReady = opt.onReady;
        this.onAudioOutputUpdate = opt.onAudioOutputUpdate;
        this.onVideoResolutionUpdate = opt.onVideoResolutionUpdate
        this.onDeviceChange = opt.onDeviceChange

        this.isReady = false;

        this.currentDevicesId = {
            audio: null,
            video: null
        }

        this.audioOutputDeviceId = this.getStorageValue('audiooutput') || 'default';

        this.facingMode = 'environment';

        let videoResolution;
        try {
            videoResolution = JSON.parse(this.getStorageValue('videoResolution'));
        }
        catch(err) {}

        if(!videoResolution)
            videoResolution = {send: 'auto', recv: 'auto'};
        
        this.videoResolution = videoResolution;

        

        //this.inDeviceChanging = false;
        navigator.mediaDevices.addEventListener('devicechange', async (event) => {            

            console.log('event', event);
            
            //document.getElementById('log_test').innerHTML += 'devicechange before<br>';
            if(isIOS && this.dontListenTheFirstDeviceChange && this.deviceChangeCount === 0) {
                this.deviceChangeCount++;
                return;
            }        

            if(this.deviceChangeTimeout)
                clearTimeout(this.deviceChangeTimeout);

            //document.getElementById('log_test').innerHTML += 'devicechange>event:' + JSON.stringify(event) + '<br>';
           
        
            //event.preventDefault();
            //if(!this.inDeviceChanging) {
            //    this.inDeviceChanging = true;
           // window.sdk.event().emit('loadingStart');
            this.deviceChangeTimeout = setTimeout(async () => {
                this._devices = {};
                await this.enumerate(true);
                try {
                    //await window.sdk.sleep(3000);
                    await this.onDeviceChange();
                }
                catch(err) {
                    
                }
                //window.sdk.event().emit('loadingStop');
                //this.inDeviceChanging = false;
            }, 1000);
            //}
        });
    }

    async needAccept() {
        await this.enumerate();
        return this._needAccept;
    }

    getDevices() {
        return this._devices;
    }

    async enumerate(needToForce = false) {
        if (this._isDeviceListReady && !needToForce)
            return this._devices;
		
        let devices = await navigator.mediaDevices.enumerateDevices().catch(function(err) {
            console.error(err.name + ": " + err.message);
        });
		

        for (var i in devices) {
            if (devices[i].label === "") {
                this._needAccept = true;
                break;
            }
        }

        if(this._needAccept && isIOS) {
            //specific for ios
            this.dontListenTheFirstDeviceChange = true;
            this.deviceChangeCount = 0;
        }
		
        if (!this._needAccept || needToForce) {
            for (var i in devices) {
                let device = devices[i];
                if (!this._devices[device.kind])
                    this._devices[device.kind] = [];
                this._devices[device.kind].push(device);
            }
            this._isDeviceListReady = true;
        }

        return this._devices;
    }

    async getUserMedia() {
        let audioDeviceId = false;
        let videoDeviceId = false;

        let constraints = { video: { width: VIDEO_WIDTH, height: VIDEO_HEIGHT }, audio: true };

        //try to find if a history of source selected is stored
        let deviceRecorder;
        try {
            deviceRecorder = JSON.parse(this.getStorageValue('devices'));
        }
        catch(err) {

        }

        if(deviceRecorder && typeof deviceRecorder == 'object') {
            audioDeviceId = deviceRecorder.audio;
            videoDeviceId = deviceRecorder.video;
        }

        if (audioDeviceId && audioDeviceId != 'null') {
            let finded = false;
            for(var i in this._devices['audioinput']) {
                if(this._devices['audioinput'][i].deviceId == audioDeviceId)
                    finded = true;
            }
            if(finded) {
                constraints.audio = {
                    deviceId: {
                        exact: audioDeviceId
                    }
                }
            }
        }

        if (videoDeviceId && videoDeviceId != 'null') {
            let finded = false;
            for(var i in this._devices['videoinput']) {
                if(this._devices['videoinput'][i].deviceId == videoDeviceId)
                    finded = true;
            }
            if(finded) {
                constraints.video.deviceId = {
                    exact: videoDeviceId
                }
            }
        }

        if(window.sdk.session().isExtern()) {
            delete constraints.video.deviceId;
            constraints.video.facingMode = this.facingMode;    
            //constraints.audio = false;             
        }

        let error = false;
        let errorObject;
        //alert(JSON.stringify(constraints));
        this.stream = await navigator.mediaDevices.getUserMedia(constraints).catch((err) => {
            error = true;
            errorObject = err;
        });
        
        if (error)
            return { error, errorObject };

        if (!this.isReady) {
            this.onReady();
            this.isReady = false;
        }

        this.currentDevicesId.audio = this.getCurrentDeviceId('audioinput');
        this.currentDevicesId.video = this.getCurrentDeviceId('videoinput');

        this.store('devices', JSON.stringify(this.currentDevicesId));

        //alert('============>' + this.stream.getVideoTracks().length);
        //document.getElementById('log_test').innerHTML += '============>' + this.stream.getVideoTracks().length + '<br>';

        return this.stream;
    }

    isStreamReady() {
        return this.isReady;
    }

    getStream() {
        return this.stream;
    }

    getAudioTrack() {
        const tracks = this.stream.getTracks();
        let track;
        for (let j in tracks) {
            if(tracks[j].kind == 'audio')
                track = tracks[j]
        }
        return track;
    }

    setAudioOutputDeviceId(deviceId) {
        this.onAudioOutputUpdate({
            deviceId
        });
        this.store('audiooutput', deviceId);
        this.audioOutputDeviceId = deviceId;
    }

    getAudioOutputDeviceId() {
        return this.audioOutputDeviceId;
    }

    setVideoResolution(kind, value) {
        this.onVideoResolutionUpdate({
            kind, value
        });
        this.videoResolution[kind] = value
        this.store('videoResolution', JSON.stringify(this.videoResolution));
    }

    getVideoResolution(kind) {
        return this.videoResolution[kind];
    }

    getAudioOutputDeviceId() {
        return this.audioOutputDeviceId;
    }

    store(key, value) {
        window.localStorage.setItem(key, value);
    }

    getStorageValue(key) {
        if(isIOS)
            return false;
        return window.localStorage.getItem(key);
    }

    async update(kind, deviceId) {
        kind = kind.startsWith('audio') ? 'audio' : 'video';
        await this.pauseTrack(kind);        
        this.currentDevicesId[kind] = deviceId;
        this.store('devices', JSON.stringify(this.currentDevicesId));
        await this.resumeTrack(kind);
    }
    
    stop() {
        if (this.stream) {
            const tracks = this.stream.getTracks();
            for (let j in tracks) {
                tracks[j].stop();
            }
        }
    }

    async pauseTrack(kind) {
        const tracks = this.stream.getTracks();
        for (let i in tracks) {
            if(tracks[i].kind == kind) {
                //tracks[i].dispatchEvent(new Event("ended"));
                await tracks[i].stop();
                await this.stream.removeTrack(tracks[i]);
            }
        }
    }

    async resumeTrack(kind, opt = {}) {
        let options = {
            media: kind, 
            deviceId: this.currentDevicesId[kind]
        }
        if(opt.facingMode) {
            delete opt.deviceId
            options.facingMode = opt.facingMode;
        }

        let stream = await this.getSpecificDeviceStream(options);
        const tracks = stream.getTracks();
        for (let i in tracks) {
            if(tracks[i].kind == kind) {
                this.stream.addTrack(tracks[i]);   
                let stream = this.stream;
                if(kind == 'audio') {
                    if(this.gainActivated) {                        
                        this.gain.setInputTrack(tracks[i]);
                        stream = new MediaStream([this.gain.getOutputTrack()]);
                    }
                }      
                this.onDeviceUpdate({
                    kind,
                    deviceId: this.currentDevicesId[kind],
                    stream
                })
            }
        }
    }

    async saveDevice(kind) {

    }

    async getDevice(kind) {

    }

    getCurrentDeviceId(kind) {
        let currentTrack;

        if(kind == 'audiooutput')
            return isChrome ? this.getAudioOutputDeviceId() : false;

        if (kind == 'videoinput')
            currentTrack = this.stream.getVideoTracks()[0];

        if (kind == 'audioinput')
            currentTrack = this.stream.getAudioTracks()[0];

        if (!currentTrack)
            return false;

        for (var i in this._devices[kind]) {
            if (this._devices[kind][i] && this._devices[kind][i].label && currentTrack.label == this._devices[kind][i].label) {
                return this._devices[kind][i].deviceId;
            }
        }

    }

    getCurrentDeviceLabel(kind) {
        let currentTrack;

        if(kind == 'audiooutput')
            return isChrome ? this.getAudioOutputDeviceId() : false;

        if (kind == 'videoinput')
            currentTrack = this.stream.getVideoTracks()[0];

        if (kind == 'audioinput')
            currentTrack = this.stream.getAudioTracks()[0];

        if (!currentTrack)
            return false;

        for (var i in this._devices[kind]) {
            if (this._devices[kind][i] && this._devices[kind][i].label && currentTrack.label == this._devices[kind][i].label) {
                return this._devices[kind][i].label;
            }
        }
    }

    autoplayDetection() {
        return new Promise((resolve, reject) => {
            
            var mp3 = 'data:audio/mpeg;base64,/+MYxAAAAANIAUAAAASEEB/jwOFM/0MM/90b/+RhST//w4NFwOjf///PZu////9lns5GFDv//l9GlUIEEIAAAgIg8Ir/JGq3/+MYxDsLIj5QMYcoAP0dv9HIjUcH//yYSg+CIbkGP//8w0bLVjUP///3Z0x5QCAv/yLjwtGKTEFNRTMuOTeqqqqqqqqqqqqq/+MYxEkNmdJkUYc4AKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq';
            var ogg = 'data:audio/ogg;base64,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';

            try {
                var isSended = false;
                var audio = new Audio();
                var src = audio.canPlayType('audio/ogg') ? ogg : mp3;
                audio.autoplay = true;
                audio.volume = 1;

                // this will only be triggered if autoplay works
                audio.addEventListener('play', function() {
                    isSended = true;
                    resolve(true);
                });
                
                setTimeout(() => {
                    if(!isSended)
                        resolve(false);
                }, 1000)

                audio.src = src;
            }
            catch (e) {
                console.error('auto play is not possible');
                resolve(false)
            }
        });
    }

    async getScreenShareStream(opt) {
        let res = true;
        try {
            this.screenStream = await navigator.mediaDevices.getDisplayMedia({
                video: {displaySurface: 'window'},
                audio: opt.audio || false
            });
        }
        catch(err) {
            res = false;
        }

        if(!this.screenStream)
            return false;
        
        if(!res)
            return res;
        
        this.screenStream.getVideoTracks()[0].addEventListener('ended', () => {
            opt.onStop();
        });
        
        return this.screenStream;
    }

    async removeScreenShareStream() {
        const streamTracks = this.screenStream.getTracks();
        for (let i in streamTracks) {
            streamTracks[i].stop();
        }
    }

    async getSpecificDeviceStream(opt) {
        let error, errorObject;
        let constraints = {};        
        constraints[opt.media] = {            
            deviceId: {
                exact: opt.deviceId
            }
        }        

        if(opt.media == 'audio') {
            let isStetho = false;
            if(opt.device && opt.device.label.startsWith('Entrée ligne'))
                isStetho = true;
            console.log('getSpecificDeviceStream', 'isStetho', isStetho)
            if(isStetho) {                
                constraints[opt.media].echoCancellation = false;     // Désactivation de la suppression de l'écho
                constraints[opt.media].noiseSuppression = false;    // Désactivation de la suppression du bruit
                constraints[opt.media].autoGainControl = false;     // Désactivation du contrôle automatique de gain
            }
        }
        if(opt.media == 'video') {
            constraints[opt.media].width = VIDEO_WIDTH;
            constraints[opt.media].height = VIDEO_HEIGHT;
        }
        console.log('constraints', constraints);
        let stream = await navigator.mediaDevices.getUserMedia(constraints).catch((err) => {
            error = true;
            errorObject = err;
        });

        return stream;
    }

    async removeSpecificDeviceStream(stream) {
        const streamTracks = stream.getTracks();
        for (let i in streamTracks) {
            streamTracks[i].stop();
        }
    }

    setGain(gain) {
        this.gainActivated = true;
        this.gain = gain;
        let track = this.gain.getOutputTrack();
        //this.stream.addTrack(tracks[i]);         
        this.onDeviceUpdate({
            kind: 'audio',
            stream: new MediaStream([track])
        })
    }

    toggleFlash() {
        if(this.flashActivated) {
            const track = this.stream.getVideoTracks()[0];
            track.applyConstraints({
                advanced: [{torch: true}]
              });
        }
        else {
            const track = this.stream.getVideoTracks()[0];
            track.applyConstraints({
                advanced: [{torch: false}]
              });
        }
        this.flashActivated = !this.flashActivated
    }

    async toggleCam() {

        window.sdk.event().emit('loadingStart');

        if(!this.currentDevicesId['video'])
            this.currentDevicesId['video'] = this.getCurrentDeviceId('videoinput');

        if(true) {
            let label = this.getCurrentDeviceLabel('videoinput');    
            if(label.includes('front') || label.includes('avant')) {      
                for (var i in this._devices['videoinput']) {
                    if (this._devices['videoinput'][i] && (this._devices['videoinput'][i].label.includes('back') || this._devices['videoinput'][i].label.includes('arrière'))) {
                        await this.update('video', this._devices['videoinput'][i].deviceId);        
                    }
                }
            }
            else {  
                for (var i in this._devices['videoinput']) {
                    if (this._devices['videoinput'][i] && (this._devices['videoinput'][i].label.includes('front') || this._devices['videoinput'][i].label.includes('avant'))) {
                        await this.update('video', this._devices['videoinput'][i].deviceId);        
                    }
                }
            }
        }
        else {
            if(this.currentDevicesId['video'] == this._devices['videoinput'][0].deviceId)
                await this.update('video', this._devices['videoinput'][1].deviceId);
            else {
                if(this.currentDevicesId['video'] == this._devices['videoinput'][1].deviceId)
                    await this.update('video', this._devices['videoinput'][0].deviceId);
            }
        }

        await window.sdk.sleep(1000);

        window.sdk.event().emit('loadingStop');

        //maybe useful for some devices
        /*await this.pauseTrack('video');        
        this.facingMode = this.facingMode == 'environment' ? 'user' : 'environment';
        await this.resumeTrack('video', {
            facingMode: this.facingMode
        });*/   
    }

}
